module.exports = __webpack_public_path__ + "static/media/CS1 -- 1.1.055e59b0.png";